import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { borderRadius, borderTop } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Box from '../Box';
import Text from '../Text';
import { SpreadsheetContext } from './SpreadsheetManager';
const StyledSpreadsheetFooter = styled(Text).withConfig({
  displayName: "SpreadsheetFooter__StyledSpreadsheetFooter",
  componentId: "sc-1usxke8-0"
})(["", " ", " border-top-left-radius:0;border-top-right-radius:0;border-top:", ";"], borderRadius, borderTop, props => themeGet('borders.bold')(props));
const SpreadsheetFooter = /*#__PURE__*/React.memo(props => {
  const {
    rows
  } = React.useContext(SpreadsheetContext);
  return /*#__PURE__*/React.createElement(StyledSpreadsheetFooter, props, rows.length, " items");
});
SpreadsheetFooter.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...borderTop.propTypes,
  onAddFilter: PropTypes.func,
  onExportCsv: PropTypes.func,
  onManageColumns: PropTypes.func,
  onMaximizeSize: PropTypes.func,
  onRestoreSize: PropTypes.func
};
SpreadsheetFooter.defaultProps = {
  bg: 'gray.1',
  borderTop: 'bold',
  borderRadius: 'corner',
  fontSize: 1,
  py: 2,
  px: 3
};
SpreadsheetFooter.displayName = 'SpreadsheetFooter';
export default SpreadsheetFooter;